/** @format */
import axios from 'axios';

import { ContentfulQueryId } from '@toucan/common/contentful';
import { normalizeIsoCode } from '@toucan/common/helpers/language';

import { ContentfulQueryVariables } from '../config/types';

/**
 * Generic Contentful data fetcher
 */
export const getContentfulData = async <R = unknown>(
    queryId: ContentfulQueryId,
    locale: string,
    variables?: ContentfulQueryVariables
): Promise<R> => {
    const normalizedLocale = normalizeIsoCode(locale);

    const params = {
        locale: normalizedLocale,
        queryId,
        variables,
    };

    const { data } = await axios.get('/cms/contentful', {
        params,
    });

    return data?.data ?? null;
};
